import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';
import { IoLogOutOutline } from 'react-icons/io5';
import { IoMdNotifications } from 'react-icons/io';
import axios from 'axios';

const Navbar = () => {
  const username = localStorage.getItem('name');
  const userId = parseInt(localStorage.getItem('userId'));
  const userRole = localStorage.getItem('role');
  const userDepartment = localStorage.getItem('department');
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);
  const [deptUnreadCount, setDeptUnreadCount] = useState(0);
  const [userUnreadCount, setUserUnreadCount] = useState(0);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  const fetchUnreadCount = async () => {
    try {
      if (userId && userRole) {
        const response = await axios.get('https://backend.ems.hiradentallab.com/api/announcements/unread-count', {
          params: { userId, role: userRole },
        });
        setUnreadCount(response.data.count);
      }
    } catch (error) {
      console.error('Error fetching unread count:', error);
    }
  };

  const fetchDeptUnreadCount = async () => {
    try {
      if (userId && userDepartment) {
        const response = await axios.get('https://backend.ems.hiradentallab.com/api/deptannouncements/unread-count', {
          params: { userId, department: userDepartment },
        });
        setDeptUnreadCount(response.data.count);
      }
    } catch (error) {
      console.error('Error fetching department unread count:', error);
    }
  };

  const fetchUserUnreadCount = async () => {
    try {
      if (userId) {
        const response = await axios.get('https://backend.ems.hiradentallab.com/api/user/userannouncements/unread-count', {
          params: { userId },
        });
        setUserUnreadCount(response.data.count);
      }
    } catch (error) {
      console.error('Error fetching user unread count:', error);
    }
  };

  useEffect(() => {
    const checkSession = () => {
      const loginTime = localStorage.getItem('loginTime');
      if (loginTime && Date.now() - parseInt(loginTime) > 60 * 60 * 1000) {
        handleLogout();
      }
    };
    const interval = setInterval(checkSession, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchUnreadCount();
    fetchDeptUnreadCount();
    fetchUserUnreadCount();

    const interval = setInterval(() => {
      fetchUnreadCount();
      fetchDeptUnreadCount();
      fetchUserUnreadCount();
    }, 30000);

    return () => clearInterval(interval);
  }, [userId, userRole, userDepartment]);

  const handleNotificationClick = () => {
    navigate('/emp-announcements');
  };

  const totalUnreadCount = unreadCount + deptUnreadCount + userUnreadCount;

  return (
    <nav className="navbarrrr">
      <div className="navbar-left">
        <div className="navbar-headerrr">Hira EMS</div>
      </div>
      <div className="navbar-welcome">
        {username ? `Welcome, ${username}!` : 'Welcome, Guest!'}
      </div>
      <div className="navbar-right">
        <div className="notification-bell" onClick={handleNotificationClick}>
          <IoMdNotifications className="bell-icon" />
          {totalUnreadCount > 0 && (
            <span className="notification-badge">{totalUnreadCount}</span>
          )}
        </div>
        <button className="logout-button" onClick={handleLogout}>
          <IoLogOutOutline className="logout-icon" />
        </button>
      </div>
    </nav>
  );
};

export default Navbar;